export interface Ability {
  name: string;
  path: string;
}

// prettier-ignore
export const abilities: Ability[] = [
  {
    name: "Air Magic",
    path: "abilities/air_magic.png"
  },
  {
    name: "Archery",
    path: "abilities/archery.png"
  },
  {
    name: "Artillery",
    path: "abilities/artillery.png"
  },
  {
    name: "Armorer",
    path: "abilities/armorer.png"
  },
  {
    name: "Eagle Eye",
    path: "abilities/eagle_eye.png"
  },
  {
    name: "Earth Magic",
    path: "abilities/earth_magic.png"
  },
  {
    name: "Estates",
    path: "abilities/estates.png"
  },
  {
    name: "Fire Magic",
    path: "abilities/fire_magic.png"
  },
  {
    name: "First Aid",
    path: "abilities/first_aid.png"
  },
  {
    name: "Intelligence",
    path: "abilities/intelligence.png"
  },
  {
    name: "Leadership",
    path: "abilities/leadership.png"
  },
  {
    name: "Logistics",
    path: "abilities/logistics.png"
  },
  {
    name: "Luck",
    path: "abilities/luck.png"
  },
  {
    name: "Necromancy",
    path: "abilities/necromancy.png"
  },
  {
    name: "Offense",
    path: "abilities/offense.png"
  },
  {
    name: "Resistance",
    path: "abilities/resistance.png"
  },
  {
    name: "Scouting",
    path: "abilities/scouting.png"
  },
  {
    name: "Sorcery",
    path: "abilities/sorcery.png"
  },
  {
    name: "Water Magic",
    path: "abilities/water_magic.png"
  },
  {
    name: "Wisdom",
    path: "abilities/wisdom.png"
  }
];
